{
  "auth": {
    "user_pool_id": "eu-central-1_BT4nt5boH",
    "aws_region": "eu-central-1",
    "user_pool_client_id": "ga7mg1ncl3cffk2m4a0e7sdt9",
    "identity_pool_id": "eu-central-1:36776bce-f7dd-47db-8f4b-ca3f629c3b9e",
    "mfa_methods": [],
    "standard_required_attributes": [
      "email"
    ],
    "username_attributes": [
      "email"
    ],
    "user_verification_types": [
      "email"
    ],
    "groups": [],
    "mfa_configuration": "NONE",
    "password_policy": {
      "min_length": 8,
      "require_lowercase": true,
      "require_numbers": true,
      "require_symbols": true,
      "require_uppercase": true
    },
    "unauthenticated_identities_enabled": true,
    "oauth": {
      "identity_providers": [],
      "domain": "eggsconnect.auth.eu-central-1.amazoncognito.com",
      "scopes": ["openid", "email", "profile", "aws.cognito.signin.user.admin"],
      "redirect_sign_in_uri": ["https://localhost:9080/", "http://localhost:9080/", "https://1884555-eggsconnectapp-stage.adobeio-static.net/", "https://1884555-eggsconnectapp.adobeio-static.net/", "https://connect-stage.eggsunimedia.com/", "https://connect.eggsunimedia.com/", "https://connect-stage.dev.eggs.de/", "https://connect.eggs.de/"],
      "redirect_sign_out_uri": ["https://localhost:9080/", "http://localhost:9080/", "https://1884555-eggsconnectapp-stage.adobeio-static.net/", "https://1884555-eggsconnectapp.adobeio-static.net/", "https://connect-stage.eggsunimedia.com/", "https://connect.eggsunimedia.com/", "https://connect-stage.dev.eggs.de/", "https://connect.eggs.de/"],
      "response_type": "code"
    }
  },
  "data": {
    "url": "https://yvkep3banjfstgoplip774dhwq.appsync-api.eu-central-1.amazonaws.com/graphql",
    "aws_region": "eu-central-1",
    "default_authorization_type": "AMAZON_COGNITO_USER_POOLS",
    "authorization_types": [
      "AWS_IAM"
    ],
    "model_introspection": {
      "version": 1,
      "models": {
        "Message": {
          "name": "Message",
          "fields": {
            "id": {
              "name": "id",
              "isArray": false,
              "type": "ID",
              "isRequired": true,
              "attributes": []
            },
            "content": {
              "name": "content",
              "isArray": false,
              "type": "String",
              "isRequired": true,
              "attributes": []
            },
            "username": {
              "name": "username",
              "isArray": false,
              "type": "String",
              "isRequired": true,
              "attributes": []
            },
            "userId": {
              "name": "userId",
              "isArray": false,
              "type": "String",
              "isRequired": true,
              "attributes": []
            },
            "createdAt": {
              "name": "createdAt",
              "isArray": false,
              "type": "AWSDateTime",
              "isRequired": false,
              "attributes": []
            },
            "updatedAt": {
              "name": "updatedAt",
              "isArray": false,
              "type": "AWSDateTime",
              "isRequired": false,
              "attributes": [],
              "isReadOnly": true
            }
          },
          "syncable": true,
          "pluralName": "Messages",
          "attributes": [
            {
              "type": "model",
              "properties": {}
            },
            {
              "type": "auth",
              "properties": {
                "rules": [
                  {
                    "provider": "userPools",
                    "ownerField": "userId",
                    "allow": "owner",
                    "identityClaim": "cognito:username",
                    "operations": [
                      "create",
                      "update",
                      "delete",
                      "read"
                    ]
                  },
                  {
                    "allow": "private",
                    "operations": [
                      "read"
                    ]
                  }
                ]
              }
            }
          ],
          "primaryKeyInfo": {
            "isCustomPrimaryKey": false,
            "primaryKeyFieldName": "id",
            "sortKeyFieldNames": []
          }
        },
        "Rating": {
          "name": "Rating",
          "fields": {
            "id": {
              "name": "id",
              "isArray": false,
              "type": "ID",
              "isRequired": true,
              "attributes": []
            },
            "presentationId": {
              "name": "presentationId",
              "isArray": false,
              "type": "String",
              "isRequired": true,
              "attributes": []
            },
            "rating": {
              "name": "rating",
              "isArray": false,
              "type": "Int",
              "isRequired": true,
              "attributes": []
            },
            "comment": {
              "name": "comment",
              "isArray": false,
              "type": "String",
              "isRequired": false,
              "attributes": []
            },
            "userId": {
              "name": "userId",
              "isArray": false,
              "type": "String",
              "isRequired": true,
              "attributes": []
            },
            "createdAt": {
              "name": "createdAt",
              "isArray": false,
              "type": "AWSDateTime",
              "isRequired": false,
              "attributes": []
            },
            "updatedAt": {
              "name": "updatedAt",
              "isArray": false,
              "type": "AWSDateTime",
              "isRequired": false,
              "attributes": [],
              "isReadOnly": true
            }
          },
          "syncable": true,
          "pluralName": "Ratings",
          "attributes": [
            {
              "type": "model",
              "properties": {}
            },
            {
              "type": "auth",
              "properties": {
                "rules": [
                  {
                    "provider": "userPools",
                    "ownerField": "userId",
                    "allow": "owner",
                    "identityClaim": "cognito:username",
                    "operations": [
                      "create",
                      "update",
                      "delete",
                      "read"
                    ]
                  },
                  {
                    "allow": "private",
                    "operations": [
                      "read"
                    ]
                  }
                ]
              }
            }
          ],
          "primaryKeyInfo": {
            "isCustomPrimaryKey": false,
            "primaryKeyFieldName": "id",
            "sortKeyFieldNames": []
          }
        },
        "Question": {
          "name": "Question",
          "fields": {
            "id": {
              "name": "id",
              "isArray": false,
              "type": "ID",
              "isRequired": true,
              "attributes": []
            },
            "sessionId": {
              "name": "sessionId",
              "isArray": false,
              "type": "String",
              "isRequired": true,
              "attributes": []
            },
            "content": {
              "name": "content",
              "isArray": false,
              "type": "String",
              "isRequired": true,
              "attributes": []
            },
            "authorId": {
              "name": "authorId",
              "isArray": false,
              "type": "String",
              "isRequired": true,
              "attributes": []
            },
            "authorName": {
              "name": "authorName",
              "isArray": false,
              "type": "String",
              "isRequired": true,
              "attributes": []
            },
            "voteCount": {
              "name": "voteCount",
              "isArray": false,
              "type": "Int",
              "isRequired": false,
              "attributes": []
            },
            "isAnswered": {
              "name": "isAnswered",
              "isArray": false,
              "type": "Boolean",
              "isRequired": false,
              "attributes": []
            },
            "answer": {
              "name": "answer",
              "isArray": false,
              "type": "String",
              "isRequired": false,
              "attributes": []
            },
            "answeredBy": {
              "name": "answeredBy",
              "isArray": false,
              "type": "String",
              "isRequired": false,
              "attributes": []
            },
            "answeredAt": {
              "name": "answeredAt",
              "isArray": false,
              "type": "AWSDateTime",
              "isRequired": false,
              "attributes": []
            },
            "createdAt": {
              "name": "createdAt",
              "isArray": false,
              "type": "AWSDateTime",
              "isRequired": false,
              "attributes": []
            },
            "updatedAt": {
              "name": "updatedAt",
              "isArray": false,
              "type": "AWSDateTime",
              "isRequired": false,
              "attributes": [],
              "isReadOnly": true
            }
          },
          "syncable": true,
          "pluralName": "Questions",
          "attributes": [
            {
              "type": "model",
              "properties": {}
            },
            {
              "type": "auth",
              "properties": {
                "rules": [
                  {
                    "provider": "userPools",
                    "ownerField": "authorId",
                    "allow": "owner",
                    "identityClaim": "cognito:username",
                    "operations": [
                      "create",
                      "update",
                      "delete",
                      "read"
                    ]
                  },
                  {
                    "allow": "private",
                    "operations": [
                      "read"
                    ]
                  }
                ]
              }
            }
          ],
          "primaryKeyInfo": {
            "isCustomPrimaryKey": false,
            "primaryKeyFieldName": "id",
            "sortKeyFieldNames": []
          }
        },
        "Vote": {
          "name": "Vote",
          "fields": {
            "id": {
              "name": "id",
              "isArray": false,
              "type": "ID",
              "isRequired": true,
              "attributes": []
            },
            "questionId": {
              "name": "questionId",
              "isArray": false,
              "type": "String",
              "isRequired": true,
              "attributes": []
            },
            "userId": {
              "name": "userId",
              "isArray": false,
              "type": "String",
              "isRequired": true,
              "attributes": []
            },
            "createdAt": {
              "name": "createdAt",
              "isArray": false,
              "type": "AWSDateTime",
              "isRequired": false,
              "attributes": []
            },
            "updatedAt": {
              "name": "updatedAt",
              "isArray": false,
              "type": "AWSDateTime",
              "isRequired": false,
              "attributes": [],
              "isReadOnly": true
            }
          },
          "syncable": true,
          "pluralName": "Votes",
          "attributes": [
            {
              "type": "model",
              "properties": {}
            },
            {
              "type": "auth",
              "properties": {
                "rules": [
                  {
                    "provider": "userPools",
                    "ownerField": "userId",
                    "allow": "owner",
                    "identityClaim": "cognito:username",
                    "operations": [
                      "create",
                      "update",
                      "delete",
                      "read"
                    ]
                  },
                  {
                    "allow": "private",
                    "operations": [
                      "read"
                    ]
                  }
                ]
              }
            }
          ],
          "primaryKeyInfo": {
            "isCustomPrimaryKey": false,
            "primaryKeyFieldName": "id",
            "sortKeyFieldNames": []
          }
        }
      },
      "enums": {},
      "nonModels": {}
    }
  },
  "version": "1.4"
}